import TargetList from './TargetList';

export default TargetList;
